import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';

@Component({
  selector: 'fc-logout',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LogoutComponent {
  constructor(private store: Store<fromStore.State>) {
    this.store.dispatch(fromStore.logOutCurrentUserAction());
  }
}
